import * as i0 from '@angular/core';
import { Injectable, Component, Input, EventEmitter, Output, NgModule } from '@angular/core';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@roosevelt/notification-lib';
import { NotificationLibModule } from '@roosevelt/notification-lib';
import { Subject, BehaviorSubject, throwError, Observable } from 'rxjs';
import * as i4 from '@roosevelt/common-ui-lib/loader';
import { LoaderModule } from '@roosevelt/common-ui-lib/loader';
import moment from 'moment';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';

class ProcLoaderModel {
}

class ProcLoaderService {
    constructor() {
        /* should use Lux */
        this.loaderSubject = new Subject();
        this.loaderObserver = this.loaderSubject.asObservable();
        this.loaderModel = new ProcLoaderModel();
        this._currentActivities = new BehaviorSubject(null);
        this.loaderTags = new Map();
    }
    show(tag) {
        this.loaderTags.set(tag, false);
        this._currentActivities.next(this.loaderTags);
    }
    hide(tag) {
        this.loaderTags.set(tag, true);
        this._currentActivities.next(this.loaderTags);
    }
    static { this.ɵfac = function ProcLoaderService_Factory(t) { return new (t || ProcLoaderService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ProcLoaderService, factory: ProcLoaderService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProcLoaderService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [], null); })();

class ProcedureConfig {
}

function ProcLoaderComponent_ng_container_0_rs_loader_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "rs-loader");
} }
function ProcLoaderComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProcLoaderComponent_ng_container_0_rs_loader_1_Template, 1, 0, "rs-loader", 0);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.hideLoader);
} }
function ProcLoaderComponent_ng_container_1_rs_loader_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "rs-loader", 2);
} }
function ProcLoaderComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProcLoaderComponent_ng_container_1_rs_loader_1_Template, 1, 0, "rs-loader", 1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.hideLoader);
} }
/* There is really no reason to have this component, but since it has this tagging system it will need to be refactored */
class ProcLoaderComponent {
    constructor(loaderService, procConfig) {
        this.loaderService = loaderService;
        this.procConfig = procConfig;
        this.hideLoader = true;
        this.subscriptions = [];
    }
    ngOnInit() {
        this.loaderType = this.procConfig.loaderType ? this.procConfig.loaderType : 'DEFAULT';
        this.loaderService.loaderObserver.subscribe((loaderModel) => {
            this.hideLoader = loaderModel.isLoading;
        });
        this.subscriptions.push(this.loaderService.
            _currentActivities.asObservable().subscribe((a) => {
            if (a != null && a.has(this.tag)) {
                this.hideLoader = a.get(this.tag);
            }
            else {
                this.hideLoader = true;
            }
        }));
    }
    ngOnDestroy() {
        this.subscriptions.forEach((x) => x.unsubscribe());
    }
    static { this.ɵfac = function ProcLoaderComponent_Factory(t) { return new (t || ProcLoaderComponent)(i0.ɵɵdirectiveInject(ProcLoaderService), i0.ɵɵdirectiveInject(ProcedureConfig)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ProcLoaderComponent, selectors: [["lib-proc-loader"]], inputs: { tag: "tag" }, decls: 2, vars: 2, consts: [[4, "ngIf"], ["imageSrc", "./assets/images/roosevelt-loader.gif", 4, "ngIf"], ["imageSrc", "./assets/images/roosevelt-loader.gif"]], template: function ProcLoaderComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ProcLoaderComponent_ng_container_0_Template, 2, 1, "ng-container", 0)(1, ProcLoaderComponent_ng_container_1_Template, 2, 1, "ng-container", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.loaderType === "DEFAULT");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.loaderType === "CUSTOM");
        } }, dependencies: [i3.NgIf, i4.LoaderComponent] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProcLoaderComponent, [{
        type: Component,
        args: [{ selector: 'lib-proc-loader', template: "<ng-container *ngIf=\"loaderType === 'DEFAULT'\">\n<rs-loader *ngIf=\"!hideLoader\"></rs-loader>\n</ng-container>\n<ng-container *ngIf=\"loaderType === 'CUSTOM'\">\n<rs-loader *ngIf=\"!hideLoader\" imageSrc=\"./assets/images/roosevelt-loader.gif\"></rs-loader>\n</ng-container>\n\n" }]
    }], () => [{ type: ProcLoaderService }, { type: ProcedureConfig }], { tag: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ProcLoaderComponent, { className: "ProcLoaderComponent", filePath: "lib/common/components/proc-loader/proc-loader.component.ts", lineNumber: 16 }); })();

const TAGS = Object.freeze({
    PROCEDURE_SEARCH: 'PROCEDURE_SEARCH',
});

class ProcedureException {
    constructor() {
        this.exceptions = [];
    }
}

class ProcedureRestService {
    constructor(http, notificationService, loaderService) {
        this.http = http;
        this.notificationService = notificationService;
        this.loaderService = loaderService;
    }
    post(url, body, tag) {
        this.loaderService.show(tag);
        const requestHeaders = new HttpHeaders();
        this.notificationService.clearNotification(tag, 'error');
        return this.http.post(url, body, {
            headers: requestHeaders
        })
            .pipe(map((response) => {
            this.loaderService.hide(tag);
            return response;
        }))
            .pipe(catchError((error) => {
            this.loaderService.hide(tag);
            return this.handleError(error, tag);
        }));
    }
    handleError(responseError, tag) {
        const showErrorLink = responseError.status == 500 ? true : false;
        const procedureSearchException = this.getErrorContent(tag, responseError);
        this.notificationService.showNotification(tag, 'error', procedureSearchException.exceptions, procedureSearchException.traceId, showErrorLink);
        return throwError(procedureSearchException);
    }
    getErrorContent(tag, err) {
        const procedureSearchException = new ProcedureException();
        const exceptions = [];
        const error = err.error;
        let traceId;
        if (error && error.apiErrorResponse && error.apiErrorResponse.apiErrorList && error.apiErrorResponse.apiErrorList.length > 0) {
            error.apiErrorResponse.apiErrorList.forEach(exception => {
                exceptions.push(exception.errorMessage);
            });
            traceId = error.apiErrorResponse.traceId;
        }
        else if (error && error.apiErrorList && error.apiErrorList.length > 0) {
            error.apiErrorList.forEach(exception => {
                exceptions.push(exception.errorMessage);
            });
            traceId = error.traceId;
        }
        else if (err && err.message) {
            exceptions.push(err.message);
        }
        else {
            exceptions.push(err.error.message);
        }
        procedureSearchException.tag = tag;
        procedureSearchException.traceId = traceId;
        procedureSearchException.exceptions = exceptions;
        return procedureSearchException;
    }
    static { this.ɵfac = function ProcedureRestService_Factory(t) { return new (t || ProcedureRestService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.NotificationService), i0.ɵɵinject(ProcLoaderService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ProcedureRestService, factory: ProcedureRestService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProcedureRestService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [{ type: i1.HttpClient }, { type: i2.NotificationService }, { type: ProcLoaderService }], null); })();

class ProcedureSearchContainer {
    constructor(httpClient, config, restService) {
        this.httpClient = httpClient;
        this.config = config;
        this.restService = restService;
    }
    /* according to the post function this will never return an error, this function should just return the result of post */
    search(request, tag) {
        return new Observable(observer => {
            this.restService.post(this.config.getProcedureCodesUri, request, tag).subscribe((result) => {
                observer.next(result);
                observer.complete();
            }, error => {
                observer.error(error);
                observer.complete();
            });
        });
    }
    static { this.ɵfac = function ProcedureSearchContainer_Factory(t) { return new (t || ProcedureSearchContainer)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ProcedureConfig), i0.ɵɵinject(ProcedureRestService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ProcedureSearchContainer, factory: ProcedureSearchContainer.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProcedureSearchContainer, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [{ type: i1.HttpClient }, { type: ProcedureConfig }, { type: ProcedureRestService }], null); })();

const _c0 = a0 => [a0];
function ProcedureSearchComponent_ng_container_3_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 7)(2, "div", 8)(3, "div", 9)(4, "label", 10);
    i0.ɵɵtext(5, "Code:\u00A0 ");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 11)(7, "span");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(9, "div", 8)(10, "div", 9)(11, "label", 10);
    i0.ɵɵtext(12, "Name:\u00A0 ");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "div", 11)(14, "span");
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const procedure_r1 = ctx.$implicit;
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate(procedure_r1.code);
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(procedure_r1.nomenclature);
} }
function ProcedureSearchComponent_ng_container_3_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtext(1, "For a list of all procedure codes and names, ");
    i0.ɵɵelementStart(2, "a", 13);
    i0.ɵɵlistener("click", function ProcedureSearchComponent_ng_container_3_div_2_Template_a_click_2_listener() { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(2); ctx_r2.showAllProcedures = !ctx_r2.showAllProcedures; return i0.ɵɵresetView(ctx_r2.getProcedures()); });
    i0.ɵɵtext(3, " click here");
    i0.ɵɵelementEnd()();
} }
function ProcedureSearchComponent_ng_container_3_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtext(1, "To hide list of all procedure codes and names, ");
    i0.ɵɵelementStart(2, "a", 13);
    i0.ɵɵlistener("click", function ProcedureSearchComponent_ng_container_3_div_3_Template_a_click_2_listener() { i0.ɵɵrestoreView(_r4); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.showAllProcedures = !ctx_r2.showAllProcedures); });
    i0.ɵɵtext(3, " click here");
    i0.ɵɵelementEnd()();
} }
function ProcedureSearchComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProcedureSearchComponent_ng_container_3_div_1_Template, 16, 2, "div", 5)(2, ProcedureSearchComponent_ng_container_3_div_2_Template, 4, 0, "div", 6)(3, ProcedureSearchComponent_ng_container_3_div_3_Template, 4, 0, "div", 6);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.procedures);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.showAllProcedures);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.showAllProcedures);
} }
function ProcedureSearchComponent_div_4_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 19)(2, "div", 20);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 21);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const procedure_r5 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(procedure_r5.code);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(procedure_r5.nomenclature);
} }
function ProcedureSearchComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 15)(2, "div", 16)(3, "div", 17);
    i0.ɵɵtext(4, "Code");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 18);
    i0.ɵɵtext(6, "Name");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(7, ProcedureSearchComponent_div_4_ng_container_7_Template, 6, 2, "ng-container", 5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngForOf", ctx_r2.allProcedures);
} }
/**
 * Procedure Search Component
 *
 * @description use this component to search procedure codes
 * @example
 * <button rs-raised-button color="secondary" (click)="show1 = !show1">PROCEDURE BY CODE</button>
 * <rs-dialog *ngIf="show1" maxWidth="70%" [visible]="show1" heading="Dental Procedure Code Details">
 *   <lib-procedure-search [procedureCodes]="['D0120']" planAcronym="DDPMI"></lib-procedure-search>
 * </rs-dialog>
 * @example
 * <button rs-raised-button color="secondary" (click)="show = !show">ALL PROCEDURE CODES AND DESCRIPTION</button>
 * <rs-dialog *ngIf="show" maxWidth="70%" [visible]="show" heading="Dental Procedure Code Details">
 *   <lib-procedure-search  planAcronym="DDPMI"></lib-procedure-search>
 * </rs-dialog>
 */
class ProcedureSearchComponent {
    constructor(procedureSearchContainer, notificationService) {
        this.procedureSearchContainer = procedureSearchContainer;
        this.notificationService = notificationService;
        this.proceduresList = new EventEmitter();
        this.showAllProcedures = true;
        this.showProcedureByCode = false;
        this.procedures = [];
        this.allProcedures = [];
        this.TAGS = TAGS;
    }
    ngOnInit() {
        if (this.procedureCodes && this.procedureCodes.length > 0) {
            this.showAllProcedures = false;
            this.showProcedureByCode = true;
        }
        this.getProcedures();
    }
    getProcedures() {
        const req = this.buildProcedureRequest();
        this.procedureSearchContainer.search(req, TAGS.PROCEDURE_SEARCH).subscribe((response) => {
            if (response.procedures && response.procedures.length > 0) {
                let responseProcedures = response.procedures;
                const today = new Date().getTime();
                if (this.showActiveOnly && this.showAllProcedures) {
                    /* TODO: REFACTOR, REMOVE MOMENT, THIS CONDITION CAN BE FIGURED OUT WITH MILLISECONDS ALONE. ALSO THIS PROBABLY DOESN'T WORK WITH SAME DAY END DATE */
                    responseProcedures = responseProcedures.filter(p => (p.endDate == null || moment(p.endDate, 'YYYY-MM-DD').isSameOrAfter(today)));
                }
                this.showAllProcedures ? this.allProcedures = responseProcedures : this.procedures = responseProcedures;
                this.proceduresList.emit(responseProcedures);
            }
            else {
                this.notificationService.showNotification(TAGS.PROCEDURE_SEARCH, 'error', ['No Data found.'], '');
            }
        });
    }
    buildProcedureRequest() {
        const req = {};
        req.planAcronym = this.planAcronym;
        req.procedureCodes = !this.showAllProcedures && this.procedureCodes ? this.procedureCodes : [];
        return req;
    }
    static { this.ɵfac = function ProcedureSearchComponent_Factory(t) { return new (t || ProcedureSearchComponent)(i0.ɵɵdirectiveInject(ProcedureSearchContainer), i0.ɵɵdirectiveInject(i2.NotificationService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ProcedureSearchComponent, selectors: [["lib-procedure-search"]], inputs: { procedureCodes: "procedureCodes", planAcronym: "planAcronym", showActiveOnly: "showActiveOnly" }, outputs: { proceduresList: "proceduresList" }, decls: 5, vars: 6, consts: [["type", "error", 3, "tags"], [3, "tag"], [1, "pl-procedures-search"], [4, "ngIf"], ["class", "procedure-search-results-content scrollerbar", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["class", "row plr-30", 4, "ngIf"], [1, "bg-color"], [1, "row", "plr-15"], [1, "col-auto", "pr-0"], [1, "font-bold", "text-left"], [1, "col", "px-0"], [1, "row", "plr-30"], [3, "click"], [1, "procedure-search-results-content", "scrollerbar"], [1, "results", "rtable"], [1, "row", "rthead", "m-0"], [1, "rth", "col-2", "pr-0", "font-bold", "text-left"], [1, "rth", "col-8", "pr-0", "font-bold", "text-left"], [1, "row", "rtbody", "m-0"], [1, "rtd", "col-2", "font-bold"], [1, "rtd", "col-8"]], template: function ProcedureSearchComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelement(0, "lib-notification", 0)(1, "lib-proc-loader", 1);
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵtemplate(3, ProcedureSearchComponent_ng_container_3_Template, 4, 3, "ng-container", 3)(4, ProcedureSearchComponent_div_4_Template, 8, 1, "div", 4);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("tags", i0.ɵɵpureFunction1(4, _c0, ctx.TAGS.PROCEDURE_SEARCH));
            i0.ɵɵadvance();
            i0.ɵɵproperty("tag", ctx.TAGS.PROCEDURE_SEARCH);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.showProcedureByCode);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showAllProcedures);
        } }, dependencies: [i3.NgForOf, i3.NgIf, i2.NotificationComponent, ProcLoaderComponent], styles: [".pl-procedures-search[_ngcontent-%COMP%]   .scrollerbar[_ngcontent-%COMP%]{overflow-y:auto;overflow-x:hidden;height:520px}.pl-procedures-search[_ngcontent-%COMP%]   .plr-15[_ngcontent-%COMP%]{padding:15px 15px 0}.pl-procedures-search[_ngcontent-%COMP%]   .bg-color[_ngcontent-%COMP%]{background-color:#f0f2f5}.pl-procedures-search[_ngcontent-%COMP%]   .plr-30[_ngcontent-%COMP%]{padding:15px 15px 10px 30px}.pl-procedures-search[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#43b02a;cursor:pointer;text-decoration:underline;padding-left:5px}.pl-procedures-search[_ngcontent-%COMP%]   .procedure-search-results-content[_ngcontent-%COMP%]   .rtbody[_ngcontent-%COMP%]:nth-child(2n){background-color:#f0f2f5}.pl-procedures-search[_ngcontent-%COMP%]   .procedure-search-results-content[_ngcontent-%COMP%]   .rthead[_ngcontent-%COMP%]{border-top:1px solid #c2c2c2;border-bottom:1px solid #c2c2c2}.pl-procedures-search[_ngcontent-%COMP%]   .procedure-search-results-content[_ngcontent-%COMP%]   .rth[_ngcontent-%COMP%], .pl-procedures-search[_ngcontent-%COMP%]   .procedure-search-results-content[_ngcontent-%COMP%]   .rtd[_ngcontent-%COMP%]{padding:12px 0}.pl-procedures-search[_ngcontent-%COMP%]   .procedure-search-results-content[_ngcontent-%COMP%]   .rth[_ngcontent-%COMP%]:first-of-type, .pl-procedures-search[_ngcontent-%COMP%]   .procedure-search-results-content[_ngcontent-%COMP%]   .rtd[_ngcontent-%COMP%]:first-of-type, .pl-procedures-search[_ngcontent-%COMP%]   .procedure-search-results-content[_ngcontent-%COMP%]   .rth[_ngcontent-%COMP%]:last-of-type, .pl-procedures-search[_ngcontent-%COMP%]   .procedure-search-results-content[_ngcontent-%COMP%]   .rtd[_ngcontent-%COMP%]:last-of-type{padding-left:10px}.pl-procedures-search[_ngcontent-%COMP%]   .procedure-search-results-content[_ngcontent-%COMP%]   .rth[_ngcontent-%COMP%]{color:#636870}.pl-procedures-search[_ngcontent-%COMP%]   .procedure-search-results-content[_ngcontent-%COMP%]   .rtable[_ngcontent-%COMP%]{border-collapse:collapse;width:100%;overflow-wrap:break-word}.pl-procedures-search[_ngcontent-%COMP%]   .procedure-search-results-content[_ngcontent-%COMP%]   .results[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:nth-child(1), .pl-procedures-search[_ngcontent-%COMP%]   .procedure-search-results-content[_ngcontent-%COMP%]   .results[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:nth-child(1){width:100px}.pl-procedures-search[_ngcontent-%COMP%]   .procedure-search-results-content[_ngcontent-%COMP%]   .results[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:nth-child(2), .pl-procedures-search[_ngcontent-%COMP%]   .procedure-search-results-content[_ngcontent-%COMP%]   .results[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:nth-child(2){width:100px}.pl-procedures-search[_ngcontent-%COMP%]   .font-bold[_ngcontent-%COMP%]{font-weight:700!important}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProcedureSearchComponent, [{
        type: Component,
        args: [{ selector: 'lib-procedure-search', template: "<lib-notification [tags]=\"[TAGS.PROCEDURE_SEARCH]\" type=\"error\"></lib-notification>\n<lib-proc-loader [tag]=\"TAGS.PROCEDURE_SEARCH\"></lib-proc-loader>\n<div class=\"pl-procedures-search\">\n    <ng-container *ngIf=\"showProcedureByCode\">\n        <div *ngFor=\"let procedure of procedures\">\n            <div class=\"bg-color\">\n                <div class=\"row plr-15 \">\n                    <div class=\"col-auto pr-0\"><label class=\"font-bold text-left\">Code:&nbsp; </label></div>\n                    <div class=\"col px-0\"><span>{{procedure.code}}</span></div>\n                </div>\n            </div>\n            <div class=\"row plr-15\">\n                <div class=\"col-auto pr-0\"><label class=\"font-bold text-left\">Name:&nbsp; </label></div>\n                <div class=\"col px-0\"><span>{{procedure.nomenclature}}</span></div>\n            </div>\n        </div>\n        <div class=\"row plr-30\" *ngIf=\"!showAllProcedures\">For a list of all procedure codes and names, <a (click)=\"showAllProcedures = !showAllProcedures; getProcedures();\"> click here</a></div>\n        <div class=\"row plr-30\" *ngIf=\"showAllProcedures\">To hide list of all procedure codes and names, <a (click)=\"showAllProcedures = !showAllProcedures;\"> click here</a></div>\n    </ng-container>\n    <div class=\"procedure-search-results-content scrollerbar\" *ngIf=\"showAllProcedures\">\n        <div class=\"results rtable\">\n            <div class=\"row rthead m-0\">\n                <div class=\"rth col-2 pr-0  font-bold text-left\">Code</div>\n                <div class=\"rth col-8 pr-0  font-bold text-left\">Name</div>\n            </div>\n            <ng-container *ngFor=\"let procedure of allProcedures\">\n                <div class=\"row rtbody m-0\">\n                    <div class=\"rtd col-2 font-bold\">{{procedure.code}}</div>\n                    <div class=\"rtd col-8\">{{procedure.nomenclature}}</div>\n                </div>\n            </ng-container>\n        </div>\n    </div>\n</div>", styles: [".pl-procedures-search .scrollerbar{overflow-y:auto;overflow-x:hidden;height:520px}.pl-procedures-search .plr-15{padding:15px 15px 0}.pl-procedures-search .bg-color{background-color:#f0f2f5}.pl-procedures-search .plr-30{padding:15px 15px 10px 30px}.pl-procedures-search a{color:#43b02a;cursor:pointer;text-decoration:underline;padding-left:5px}.pl-procedures-search .procedure-search-results-content .rtbody:nth-child(2n){background-color:#f0f2f5}.pl-procedures-search .procedure-search-results-content .rthead{border-top:1px solid #c2c2c2;border-bottom:1px solid #c2c2c2}.pl-procedures-search .procedure-search-results-content .rth,.pl-procedures-search .procedure-search-results-content .rtd{padding:12px 0}.pl-procedures-search .procedure-search-results-content .rth:first-of-type,.pl-procedures-search .procedure-search-results-content .rtd:first-of-type,.pl-procedures-search .procedure-search-results-content .rth:last-of-type,.pl-procedures-search .procedure-search-results-content .rtd:last-of-type{padding-left:10px}.pl-procedures-search .procedure-search-results-content .rth{color:#636870}.pl-procedures-search .procedure-search-results-content .rtable{border-collapse:collapse;width:100%;overflow-wrap:break-word}.pl-procedures-search .procedure-search-results-content .results th:nth-child(1),.pl-procedures-search .procedure-search-results-content .results td:nth-child(1){width:100px}.pl-procedures-search .procedure-search-results-content .results th:nth-child(2),.pl-procedures-search .procedure-search-results-content .results td:nth-child(2){width:100px}.pl-procedures-search .font-bold{font-weight:700!important}\n"] }]
    }], () => [{ type: ProcedureSearchContainer }, { type: i2.NotificationService }], { procedureCodes: [{
            type: Input
        }], planAcronym: [{
            type: Input
        }], showActiveOnly: [{
            type: Input
        }], proceduresList: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ProcedureSearchComponent, { className: "ProcedureSearchComponent", filePath: "lib/modules/procedures-search/procedures-search.component.ts", lineNumber: 30 }); })();

class ProcedureSearchModule {
    static { this.ɵfac = function ProcedureSearchModule_Factory(t) { return new (t || ProcedureSearchModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ProcedureSearchModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            NotificationLibModule,
            LoaderModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProcedureSearchModule, [{
        type: NgModule,
        args: [{
                declarations: [ProcedureSearchComponent, ProcLoaderComponent],
                imports: [
                    CommonModule,
                    NotificationLibModule,
                    LoaderModule
                ],
                exports: [ProcedureSearchComponent, ProcLoaderComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ProcedureSearchModule, { declarations: [ProcedureSearchComponent, ProcLoaderComponent], imports: [CommonModule,
        NotificationLibModule,
        LoaderModule], exports: [ProcedureSearchComponent, ProcLoaderComponent] }); })();

/*
 * Public API Surface of procedures-lib
 */
/* modules */

/**
 * Generated bundle index. Do not edit.
 */

export { ProcLoaderComponent, ProcedureConfig, ProcedureSearchComponent, ProcedureSearchModule };
